if (document.body) {
	import("./components/scrollDirection.js").then(
		({ initScrollDirection }) => {
			console.log("✅ ./components/scrollDirection.js loaded!");
			initScrollDirection();
		}
	);
}

if (document.querySelector(".js-skip-to-main-content-link")) {
	import("./components/skipToMainContent.js").then(
		({ initSkipToMainContent }) => {
			console.log("✅ ./components/skipToMainContent.js loaded!");
			initSkipToMainContent();
		}
	);
}

if (document.querySelector(".js-navigation-primary")) {
	import("./components/headerMenu.js").then(({ initHeaderMenu }) => {
		console.log("✅ ./components/headerMenu.js loaded!");
		initHeaderMenu();
	});
}

if (document.querySelector("#JsFacetFiltersForm")) {
	import("./components/filters.js").then(({ initFilters }) => {
		console.log("✅ ./components/filters.js loaded!");
		initFilters();
	});
}

if (document.querySelector("#js-product-variants-json")) {
	import("./components/productFormVariants.js").then(
		({ initProductVariants }) => {
			console.log("✅ ./components/productFormVariants.js loaded!");
			initProductVariants();
		}
	);
}

if (document.getElementById("js-product-form-ajax")) {
	import("./components/productForm.js").then(({ initProductForm }) => {
		console.log("✅ ./components/productForm.js loaded!");
		initProductForm();
	});
}

if (
	document.querySelector(".js-increase-qty") ||
	document.querySelector(".js-decrease-qty")
) {
	import("./components/cartForm.js").then(({ initCartForm }) => {
		console.log("✅ ./components/cartForm.js loaded!");
		initCartForm();
	});
}

if (document.querySelector(".js-toggle")) {
	import("./components/toggle.js").then(({ Toggle }) => {
		console.log("✅ ./components/toggle.js loaded!");
		new Toggle();
	});
}

if (document.querySelector(".js-embla")) {
	import("./components/emblaInit.js").then(({ initEmbla }) => {
		initEmbla(".js-embla-carousell", {
			loop: false,
			align: "start",
			slidesToScroll: 1, // valore base (mobile)

			breakpoints: {
				"(min-width: 1024px)": {
					slidesToScroll: 4, // desktop
				},
			},
		});

		initEmbla(".js-embla-slideshow", {
			loop: false,
			align: "start",
			slidesToScroll: 1,
		});
	});
}

if (document.querySelector(".js-product-main-image")) {
	import("./components/productGallery.js").then(({ ProductGallery }) => {
		console.log("✅ ./components/productGallery.js loaded!");
		new ProductGallery();
	});
}

if (document.getElementById("js-free-shipping")) {
	import("./components/freeShippingProgress.js").then(
		({ initFreeShippingProgress }) => {
			console.log("✅ ./components/freeShippingProgress.js loaded!");
			initFreeShippingProgress();
		}
	);
}

if (document.querySelector(".js-search-input")) {
	import("./components/searchPredictive.js").then(
		({ initSearchPredictive }) => {
			console.log("✅ ./components/searchPredictive.js loaded!");
			initSearchPredictive();
		}
	);
}
